module.exports = __webpack_public_path__ + "img/paymentMethodLogo.b6eface1.png";